module.exports = __webpack_public_path__ + "static/media/hashtag.fbac13af.png";